<template>
  <b-container>
    <b-modal
      v-if="selected_waypoint"
      id="gps-modal"
      :title="selected_waypoint.name"
      hide-footer
    >
      <b-row class="my-1">
        <b-col sm="3">
          <label for="lat">Latitude</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            readonly
            id="lat"
            :value="selected_waypoint.lat"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label for="lon">Longitude</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            readonly
            id="lon"
            :value="selected_waypoint.lon"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="6">
          <b-button
            pil
            variant="outline-success"
            target="_blank"
            :href="
              'https://www.google.com/maps/dir/?api=1&destination=' +
              this.selected_waypoint.lat +
              ',' +
              this.selected_waypoint.lon
            "
          >
            Google Maps
          </b-button>
        </b-col>
        <b-col cols="6">
          <b-button
            pil
            variant="outline-success"
            target="_blank"
            :href="
              'https://ul.waze.com/ul?navigate=yes&ll=' +
              this.selected_waypoint.lat +
              ',' +
              this.selected_waypoint.lon
            "
          >
            Waze
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <h3>OpenRaideur - GPS conducteurs</h3>
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1" v-for="day in days" :key="day.id">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'day-' + day.id" variant="primary">{{
            day.name
          }}</b-button>
        </b-card-header>
        <b-collapse
          :id="'day-' + day.id"
          role="tabpanel"
          accordion="day-accordion"
        >
          <b-card-body>
            <div class="accordion" role="tablist">
              <b-card
                no-body
                class="mb-1"
                v-for="layer in day.layers"
                :key="layer.id"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'layer-' + layer.id"
                    variant="secondary"
                    >{{ layer.name }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  :id="'layer-' + layer.id"
                  role="tabpanel"
                  accordion="layer-accordion"
                >
                  <b-card-body>
                    <b-row
                      v-for="waypoint in layer.waypoints"
                      :key="waypoint.id"
                    >
                      <b-button
                        variant="link"
                        class="px-1"
                        v-b-modal="'gps-modal'"
                        @click="select_waypoint(waypoint)"
                      >
                        <font-awesome-icon
                          :icon="['fas', waypoint.icon]"
                          :color="waypoint.color"
                          fixed-width
                        />
                        {{ waypoint.name }}
                      </b-button>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </b-container>
</template>

<script>
const axios = require("axios").default;

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Gps",
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      days: [],
      selected_waypoint: null,
    };
  },
  async mounted() {
    await axios
      .get("/api/layer/")
      .then((response) => {
        let days = [];
        let day_ids = [];
        for (let day of response.data.map((l) => l.day)) {
          if (!day_ids.includes(day.id)) {
            days.push({
              id: day.id,
              name: day.name,
              layers: [],
            });
            day_ids.push(day.id);
          }
        }

        days = days.sort((x, y) => {
          return x.name > y.name ? 1 : -1;
        });

        for (let day of days) {
          day.layers = response.data
            .filter((l) => l.day.id == day.id)
            .map((l) => {
              return {
                id: l.id,
                name: l.name,
                waypoints: l.openraideur_waypoint_features.map((w) => {
                  return {
                    name: w.name,
                    icon: w.icon,
                    color: w.color,
                    lat: w.lat,
                    lon: w.lon,
                  };
                }),
              };
            });
        }
        days.forEach(
          (d) => (d.layers = d.layers.filter((l) => l.waypoints.length > 0))
        );
        this.days = days.filter((d) => d.layers.length > 0);
      })
      .catch((error) => {
        console.log("Erreur de récupération des layers !" + error);
      });
  },
  methods: {
    select_waypoint(waypoint) {
      this.selected_waypoint = waypoint;
    },
  },
};
</script>

<style>
</style>